import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { PriceDisplay } from '../ui/PriceDisplay';
export function StickyAlertBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 w-full bg-primary text-white z-[1001] h-[40px] md:h-[44px] flex items-center justify-center px-4 shadow-md" data-id="element-178">
      <p className="text-[12px] md:text-[13px] font-bold tracking-wide text-center truncate pr-6" data-id="element-179">
        PRECIO DE LANZAMIENTO: <PriceDisplay price={14.99} data-id="element-180" /> USD · TIEMPO
        LIMITADO
      </p>
      <button onClick={() => setIsVisible(false)} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-primary-dark rounded-full transition-colors" aria-label="Cerrar alerta" data-id="element-181">
        <X className="w-4 h-4" data-id="element-182" />
      </button>
    </div>;
}
export function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const vh = window.innerHeight;
      const checkoutSection = document.getElementById('checkout');
      let hideForCheckout = false;
      if (checkoutSection) {
        const rect = checkoutSection.getBoundingClientRect();
        // Hide if checkout section is in viewport
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          hideForCheckout = true;
        }
      }
      if (scrollY > vh && !hideForCheckout) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full bg-ink text-white z-[999] md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.25)] animate-in slide-in-from-bottom-full duration-300" data-id="element-183">
      <div className="flex items-center justify-between px-4 h-[60px]" data-id="element-184">
        <div className="italic font-serif text-[14px] truncate mr-4 text-cream" data-id="element-185">
          Antes de Que Sea Tarde
        </div>
        <div className="flex items-center shrink-0" data-id="element-186">
          <CTAButton className="!min-h-[44px] !h-[44px] !px-4 !text-[13px] w-[140px] !rounded-none" showUrgency={false} data-id="element-187">
            <PriceDisplay price={14.99} data-id="element-188" /> · Comprar →
          </CTAButton>
        </div>
      </div>
    </div>;
}